/* @flow */
import * as React from 'react';

import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';

type Props = {
  content: any,
};

function TextCell({ content }: Props) {
  return <Text>{content}</Text>;
}

export function getTextCellGenerator(fieldName: string) {
  return (data: Object) => {
    return <TextCell content={data[fieldName]} />;
  };
}

export function getTimestampCellGenerator(fieldName: string) {
  return (data: Object) => {
    const content = isNaN(data[fieldName]) ? null : (
      <Time date={new Date(data[fieldName])} month="short" day="numeric" year="numeric" />
    );
    return <TextCell content={content} />;
  };
}
